export enum DocumentType {
	Employee = 1,
	InvoicesAccountsPayable = 2,
	Purchasing = 3,
	AccountsPayableVendors = 4,
	CashManagementBankReconciliation = 5,
	AccountsReceivableInvoices = 6,
	BaseVersion = 7,
	JournalEntryGroup = 8,
	BankEntry = 9,
	Requisitions = 10,
	EmployeeStaffAction = 11,
	Asset = 12,
	ReviewEmployeeLinqCeus = 13,
	WorkshopManagement = 14,
	WorkshopManagementSyllabus = 15,
	PayrollReclassifyChecks = 16,
	FundReclassifyChecks = 17,
	EmployeePicture = 18,
	WorkshopCertificateSetup = 19,
	FundCashCustomerAccountsReceivable = 20,
}

export enum DocumentSiteClaimPage {
	ManageEmployeesDocMgmt = 'ManageEmployeesDocMgmt',
	EmployeeCeuDocMgmt = 'EmployeeCeuDocMgmt',
	ManageAssetDocMgmt = 'ManageAssetDocMgmt',
	ReviewEmployeeLinqCeusDocMgmt = 'ReviewEmployeeLinqCeusDocMgmt',
	WorkshopManagementDocMgmt = 'WorkshopManagementDocMgmt',
	ReclassifyChecksDocMgmt = 'ReclassifyChecksDocMgmt',
	FundReclassifyChecksDocMgmt = 'FundReclassifyChecksDocMgmt',
	WorkshopCertificateSetup = 'WorkshopCertificateSetup',
	FundCashCustomerAccountsReceivableDocMgmtDelete = 'FundCashCustomerAccountsReceivableDocMgmtDelete',
}

export enum DocMgmtContentStateEnum {
	Pending = 'pending',
	Active = 'active',
	Deleted = 'deleted',
	Cloning = 'cloning',
	RequiresVirusScan = 'requiresVirusScan',
}
